import React from 'react';

function Google() {
  return (
    <svg
      width="24"
      height="24"
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M23.52 12.2724C23.52 11.4215 23.4436 10.6033 23.3018 9.81787H12V14.4597H18.4582C18.18 15.9597 17.3345 17.2306 16.0636 18.0815V21.0924H19.9418C22.2109 19.0033 23.52 15.927 23.52 12.2724Z" // eslint-disable-line max-len -- Long lines acceptable for SVG
        fill="#4285F4"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M12.0001 24.0003C15.2401 24.0003 17.9565 22.9257 19.9419 21.093L16.0638 18.0821C14.9892 18.8021 13.6147 19.2275 12.0001 19.2275C8.87467 19.2275 6.22922 17.1166 5.28558 14.2803H1.27649V17.3894C3.25103 21.3112 7.30922 24.0003 12.0001 24.0003Z" // eslint-disable-line max-len -- Long lines acceptable for SVG
        fill="#34A853"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M5.28545 14.2799C5.04545 13.5599 4.90909 12.7908 4.90909 11.9999C4.90909 11.209 5.04545 10.4399 5.28545 9.71993V6.61084H1.27636C0.463636 8.23084 0 10.0636 0 11.9999C0 13.9363 0.463636 15.769 1.27636 17.389L5.28545 14.2799Z" // eslint-disable-line max-len -- Long lines acceptable for SVG
        fill="#FBBC05"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M12.0001 4.77224C13.7619 4.77224 15.3438 5.37769 16.5874 6.56678L20.0292 3.12497C17.951 1.1886 15.2347 -0.000488281 12.0001 -0.000488281C7.30922 -0.000488281 3.25103 2.6886 1.27649 6.61042L5.28558 9.71951C6.22922 6.88315 8.87467 4.77224 12.0001 4.77224Z" // eslint-disable-line max-len -- Long lines acceptable for SVG
        fill="#EA4335"
      />
    </svg>
  );
}

export default Google;
